import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import TitleWrap from "@components/atoms/TitleWrap";

import useMeta from "@hooks/reducerHooks/useMeta";

import { URLS } from "@const/urls";

function CustomerService() {
  const { setMetaTag } = useMeta();
  const { t } = useTranslation();

  useEffect(() => {
    setMetaTag({ title: `TUNE.KR - CUSTOMER SERVICE` });
  }, []);

  return (
    <TitleWrap className="tune-column-4 flex flex-col gap-5 leading-relax" title={t("pages.cs.title")}>
      <p>
        {t("pages.cs.description1")}
        <br />
        {t("pages.cs.description2")}
        <br />
        <Link className="underline" to={URLS.ACCOUNT}>
          {t("pages.cs.tune_url")}
        </Link>
        <br />
        <br />
        E:{" "}
        <a className="underline" href="mailto:service@tune.kr">
          {t("pages.cs.cs_email")}
        </a>
        <br />
        C:{" "}
        <a className="underline" href="https://tune-kr.channel.io" rel="noreferrer" target="_blank">
          {t("pages.cs.chat")}
        </a>
        <br />
        <br />
        {t("pages.cs.operation_hour")}
      </p>
    </TitleWrap>
  );
}

export default CustomerService;
